import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Tooltip,
  IconButton
} from '@material-ui/core';
import CustomDropDownArray from '../../../../../utils/redux-forms-custom-fields/CustomDropDownArray';
import CustomInput from '../../../../../utils/redux-forms-custom-fields/CustomInput';
import CustomInputCheckbox from '../../../../../utils/redux-forms-custom-fields/CustomDropDownArray';
import { MEMBER_TIERS_TYPE_OPTIONS } from '../../constants/options';

const MemberTiers = ({
  fields,
  meta: { error },
  questForm,
  parametersSubTab
}) => {
  const hasMemberTiers = questForm?.values?.memberTiers?.length > 0;
  const isYoutubeVideoQuest = questForm?.values?.type === 'youtube-video';

  // 根据任务类型过滤可用的 Member Tier 类型选项
  const getMemberTierTypeOptions = () => {
    if (isYoutubeVideoQuest) {
      // YouTube Video Quest 只支持 Noiz Username 和 YouTube Channel ID
      return MEMBER_TIERS_TYPE_OPTIONS.filter(
        option => option.value === 'noiz-username' || option.value === 'youtube-username'
      );
    }
    // 其他任务类型显示所有选项
    return MEMBER_TIERS_TYPE_OPTIONS;
  };

  const memberTierTypeOptions = getMemberTierTypeOptions();

  const renderRemoveButton = (memberTier, onRemove) => {
    if (memberTier.status) {
      return (
        <Tooltip title={`This Member has a status of ${memberTier.status}`} placement="top">
          <div>
            <IconButton disabled>
              <i className="fa fa-trash" />
            </IconButton>
          </div>
        </Tooltip>
      );
    }

    return (
      <Tooltip title="Remove this member tier" placement="top">
        <IconButton onClick={onRemove}>
          <i className="fa fa-trash" />
        </IconButton>
      </Tooltip>
    );
  };

  return (
    <section className="WhiteListWrapper">
      <TableContainer>
        <Table>
          {hasMemberTiers && (
            <TableHead>
              <TableRow>
                <TableCell align="center">Type of Member Tier</TableCell>
                <TableCell align="center">Username</TableCell>
                <TableCell align="center">Payment Amount</TableCell>
                <TableCell align="center">Goal Description</TableCell>
                <TableCell align="center">Enable Goal</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
          )}
          <TableBody>
            {fields.map((memberTierItem, index) => (
              <TableRow key={index}>
                <TableCell>
                  <Field
                    name={`${memberTierItem}.type`}
                    id={`${memberTierItem}.type`}
                    placeholder="Select type"
                    customLabel=""
                    component={CustomDropDownArray}
                    options={memberTierTypeOptions}
                  />
                </TableCell>
                <TableCell>
                  <Field
                    name={`${memberTierItem}.identity`}
                    id={`${memberTierItem}.identity`}
                    type="text"
                    component={CustomInput}
                    placeholder="Username"
                  />
                </TableCell>
                <TableCell>
                  <Field
                    name={`${memberTierItem}.paymentAmount`}
                    id={`${memberTierItem}.paymentAmount`}
                    type="text"
                    component={CustomInput}
                    placeholder="Payment Amount"
                  />
                </TableCell>
                <TableCell>
                  <Field
                    name={`${memberTierItem}.goal`}
                    id={`${memberTierItem}.goal`}
                    type="text"
                    component={CustomInput}
                    placeholder="Goal Description"
                  />
                </TableCell>
                <TableCell align="center">
                  <Field
                    name={`${memberTierItem}.goalEnabled`}
                    id={`${memberTierItem}.goalEnabled`}
                    type="checkbox"
                    component={CustomInputCheckbox}
                  />
                </TableCell>
                <TableCell align="center">
                  {renderRemoveButton(fields.get(index), () => {
                    if (window.confirm('Are you sure you want to remove this member tier?')) {
                      fields.remove(index);
                    }
                  })}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {error && <span className="RepeaterWrapper__error">{error}</span>}

      <button
        className="RepeaterWrapper__add-item"
        type="button"
        onClick={() => fields.push({})}
      >
        Add Another Member Tier
      </button>
    </section>
  );
};

MemberTiers.propTypes = {
  fields: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  questForm: PropTypes.object,
  parametersSubTab: PropTypes.number.isRequired
};

export default React.memo(MemberTiers);